import { useMutation, type MutationHookOptions } from "@apollo/client"
import tenantInvitationCreateManyMutation from "@/v2-backoffice-client/tenant/invitation/create/tenant.invitation.create.many.mutation.gql"
import type {
  TenantInvitationCreateManyMutation,
  TenantInvitationCreateManyMutationVariables,
} from "@/v2-backoffice-client/tenant/invitation/create/__types__/tenant.invitation.create.many.mutation"

type CreateManyOptions = MutationHookOptions<
  TenantInvitationCreateManyMutation,
  TenantInvitationCreateManyMutationVariables
>

export function useTenantInvitationCreateManyMutation(
  options?: CreateManyOptions,
) {
  return useMutation<
    TenantInvitationCreateManyMutation,
    TenantInvitationCreateManyMutationVariables
  >(tenantInvitationCreateManyMutation, options)
}
